import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/private/tmp/velova-production-build-95194f1/frontend/components/landing/motion-primitives.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/private/tmp/velova-production-build-95194f1/frontend/components/landing/site-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VelovaLogo"] */ "/private/tmp/velova-production-build-95194f1/frontend/components/velova-logo.tsx");
;
import(/* webpackMode: "eager" */ "/Users/anmol/Documents/FINAL_OPEN_CLAW/geo/frontend/node_modules/next/dist/client/link.js");
